import { isTimeout } from "@/utils/with-timeout";

/**
 * Signale à Sentry l'échec de la restauration du club au démarrage, sans le bruit attendu :
 * - une session expirée (401) se termine déjà par une déconnexion normale, avec le plafond de
 *   48 h des sessions club elle arrive à chaque poste rouvert après deux jours ;
 * - un dépassement du délai n'est pas une erreur : il part en avertissement, qui sert aussi à
 *   mesurer la latence ajoutée au démarrage.
 */
export const reportRestoreError = (Sentry, error) => {
  if (error?.response?.status === 401) {
    return;
  }

  if (isTimeout(error)) {
    Sentry.captureMessage("Restauration du club au démarrage au-delà du délai", "warning");

    return;
  }

  Sentry.captureException(error);
};